import React, { useState, useEffect, useCallback } from "react";
import Box from "@iso/components/utility/box";
import { useHistory } from "react-router-dom";
import PageHeader from "@iso/components/utility/pageHeader";
import IntlMessages from "@iso/components/utility/intlMessages";
import { useSelector, useDispatch } from "react-redux";
import { Button, Row, Col, message, Card, DatePicker, Spin, Popover, Checkbox, Radio } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";
import appActions from "@iso/redux/app/actions";
import _ from "lodash";
import HealthSafetyWrapper from "./Dashboard.styles";
import ModalHealthSafety from "./ModalHealthSafety";
import ModalActivity from "./ModalActivity";
import AddActivityModal from "@iso/containers/Pages/PropertyMap/components/Asset/AddActivityModal";
import MapHealthSafety from "./MapHealthSafety";
import DashboardSafeFarm from "@iso/containers/Pages/SafeFarm/Dashboard";
import AssetChart from "./AssetChart";
import Activity from "./Activity";
import ButtonGroup from "./ButtonGroup";
import SafetyDocumentsModal from "./SafetyDocumentsModal";
import SafetyRecords from "./SafetyRecords";
import ObservationModal from "@iso/containers/Pages/PropertyMap/components/Observation/ObservationModal";
import { propertyService } from "@iso/services";
import { healthsafety, assetService } from "@iso/services";
import modalActions from "@iso/redux/modal/actions";
import moment from "moment";
import WeatherMap from ".././WeatherMap/WeatherMap";
import { PageTitle, SectionCard } from "../Operations/OperationsUI";
import { ViewAllLink } from "./SafetyTiles";
import {
  SafetyPerformanceTile,
  TotalRecordsTile,
  IncidentsTile,
  OpenActionsTile,
  NearMissRatioTile,
  TrainingComplianceTile,
  RiskHeatMapTile,
  IncidentsOverTimeTile,
  TopHazardCategoriesTile,
  ObservationsStatusTile,
} from "./SafetyTiles";
const { RangePicker } = DatePicker;

const { openModal } = modalActions;
const { changeCurrent } = appActions;

// Tiles that the user can show/hide via the Customise control. Order matches
// the on-screen layout (KPI row then charts row).
const DASHBOARD_TILES = [
  { key: "safety_performance", label: "Safety Performance" },
  { key: "total_records", label: "Total Records" },
  { key: "incidents", label: "Incidents" },
  { key: "open_actions", label: "Open Actions" },
  { key: "near_miss_ratio", label: "Near Miss Ratio" },
  { key: "training_compliance", label: "Training Compliance" },
  { key: "risk_heat_map", label: "Risk Heat Map" },
  { key: "incidents_over_time", label: "Incidents Over Time" },
  { key: "top_hazard_categories", label: "Top Hazard Categories" },
  { key: "observations_status", label: "Observations Status" },
];
const HIDDEN_TILES_KEY = "hs_dashboard_hidden_tiles";

const Dashboard = () => {
  const activePropertyId = useSelector(
    (state) => state.property.activePropertyId
  );
  const dispatch = useDispatch();
  const [primaryObjects, setPrimaryObjects] = useState([]);
  const [position, setPosition] = useState([null, null]);
  const [propertyId, setPropertyId] = useState(null);
  const [healthAndSafetyPolicies, setHealthAndSafetyPolicies] = useState([]);
  // const [historyData, setHistoryData] = useState([]);
  const [assets, setAssets] = useState([]);
  const [visibleRader,setvisibleRader] = useState(false)
  const [healthAndSafetyAssets, setHealthAndSafetyAssets] = useState([]);
  const [visibleModalHealthSafety, setVisibleModalHealthSafety] =
    useState(false);
  const [editingAsset, setEditingAsset] = useState(null);
  const [visibleModalActivity, setVisibleModalActivity] = useState(false);
  const [activityActive, setActivityActive] = useState();
  const [editingPolicy, setEditingPolicy] = useState(null);
  const [additionalActivityData, setAdditionalActivityData] = useState(null);
  const [visibleTrainingModal, setVisibleTrainingModal] = useState(false);
  const [trainingFacilityId, setTrainingFacilityId] = useState(null);
  const [assetName, setAssetName] = useState(null);
  const history = useHistory();

  // Revamped dashboard tile data (aggregate endpoint) + selected date range.
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [visibleSafetyDocuments, setVisibleSafetyDocuments] = useState(false);
  const [mapLayer, setMapLayer] = useState("all");
  const [hiddenTiles, setHiddenTiles] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(HIDDEN_TILES_KEY)) || [];
    } catch (e) {
      return [];
    }
  });

  const isTileVisible = (key) => !hiddenTiles.includes(key);
  const toggleTile = (key, visible) => {
    setHiddenTiles((prev) => {
      const next = visible ? prev.filter((k) => k !== key) : [...new Set([...prev, key])];
      try {
        localStorage.setItem(HIDDEN_TILES_KEY, JSON.stringify(next));
      } catch (e) {
        /* localStorage unavailable — keep in-memory only */
      }
      return next;
    });
  };
  const [dateRange, setDateRange] = useState([
    moment().startOf("month"),
    moment(),
  ]);

  const goTo = useCallback(
    (path, menuKey) => {
      history.push(path);
      dispatch(changeCurrent([menuKey || path.replace(/^\//, "")]));
    },
    [history, dispatch]
  );

  const cancelModalHealthSafety = () => {
    setVisibleModalHealthSafety(false);
    setEditingAsset(null);
  };
  const showModalHealthSafety = (asset = null) => {
    setEditingAsset(asset);
    setVisibleModalHealthSafety(true);
  };

  const cancelModalActivity = () => {
    setVisibleModalActivity(false);
    setActivityActive(undefined);
    setEditingPolicy(null);
    setAdditionalActivityData(null);
  };

  const showModalActivity = (type = null, policy = null, additionalData = null) => {
    // Handle training_session with education asset selection
    if (type === 'training_session' && additionalData?.educationAsset) {
      const facilityId = additionalData.educationAsset.facility_id;
      const educationAssetName = additionalData.educationAsset.name;
      if (!facilityId) {
        console.error('No facility linked to this education asset');
        return;
      }
      setTrainingFacilityId(facilityId);
      setAssetName(educationAssetName);
      setVisibleTrainingModal(true);
      return;
    }

    setActivityActive(type || policy?.type);
    setEditingPolicy(policy || null);
    setAdditionalActivityData(additionalData);
    setVisibleModalActivity(true);
  };

  const cancelTrainingModal = () => {
    setVisibleTrainingModal(false);
    setTrainingFacilityId(null);
    setAssetName(null);
  };

  const updatePropertyDetail = React.useCallback((id) => {
    propertyService.viewProperty(id).then((res) => {
      if (res.code === "0000") {
        setPrimaryObjects(res.primary_objects);
        setPosition([res.property.lat, res.property.lng]);
      }
    });
  }, []);

  const getDataAsset = () => {
    if (activePropertyId) {
      healthsafety.getHealthAndSafetyAssets(activePropertyId).then((res) => {
        if (res.code === "0000") {
          setAssets(res.assets);
        }
      });
    }
  };

  const search = (propertyId, s) => {
    healthsafety.search(propertyId, s).then((res) => {
      if (res.code === "0000") {
        setHealthAndSafetyAssets(res.health_safety_assets);
        setHealthAndSafetyPolicies(res.health_safety_policies);
      }
    });
  };

  const getAssetsAndPolicies = () => {
    if (activePropertyId) {
      search(activePropertyId, "");
    }
  };

  useEffect(() => {
    if (activePropertyId) {
      setPropertyId(activePropertyId);
      updatePropertyDetail(activePropertyId);
      getDataAsset();
      search(activePropertyId, "");
    }
  }, [activePropertyId]);

  useEffect(() => {
    if (!activePropertyId) return;
    let cancelled = false;
    const [from, to] = dateRange || [];
    setDashboardLoading(true);
    healthsafety
      .getDashboard(
        activePropertyId,
        from ? from.format("YYYY-MM-DD") : undefined,
        to ? to.format("YYYY-MM-DD") : undefined
      )
      .then((res) => {
        if (!cancelled) setDashboardData(res?.data || null);
      })
      .catch((err) => {
        console.error("Failed to load H&S dashboard", err);
        if (!cancelled) message.error("Could not load dashboard data. Please try again.");
      })
      .finally(() => {
        if (!cancelled) setDashboardLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [activePropertyId, dateRange]);

  const onSaved = (savedAsset) => {
    updatePropertyDetail(propertyId);
  };

  const handleHazardUpdated = useCallback(() => {
    if (propertyId) {
      search(propertyId, "");
    }
  }, [propertyId]);

  const refreshHealthSafetyData = () => {
    getAssetsAndPolicies();
    getDataAsset();
  };

  const handleEditHazard = (hazard) => {
    if (!hazard) return;
    showModalActivity(hazard?.type || 'hazard', hazard);
  };

  const handleObservationSaved = () => {
    if (propertyId) {
      window.dispatchEvent(
        new CustomEvent("observation:refresh", {
          detail: { propertyId },
        })
      );
    }
  };

  const handleActivityEdit = (policy) => {
    if (!policy) return;
    showModalActivity(policy.type, policy);
  };

  const propertyCenterPoint =
    position[0] !== null && position[1] !== null
      ? { lat: position[0], lng: position[1] }
      : null;

  const d = dashboardData || {};

  return (
    <HealthSafetyWrapper>
      <PageTitle
        title="Health & Safety Dashboard"
        subtitle="Real-time overview of safety performance and activities across your operation"
        right={
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <RangePicker
              value={dateRange}
              allowClear={false}
              format="DD MMM YYYY"
              onChange={(range) => range && setDateRange(range)}
            />
            <Popover
              trigger="click"
              placement="bottomRight"
              title="Show tiles"
              content={
                <div style={{ maxHeight: 320, overflowY: "auto", minWidth: 200 }}>
                  {DASHBOARD_TILES.map((tile) => (
                    <div key={tile.key} style={{ padding: "4px 0" }}>
                      <Checkbox
                        checked={isTileVisible(tile.key)}
                        onChange={(e) => toggleTile(tile.key, e.target.checked)}
                      >
                        {tile.label}
                      </Checkbox>
                    </div>
                  ))}
                </div>
              }
            >
              <Button icon={<AppstoreOutlined />}>Customise</Button>
            </Popover>
          </div>
        }
      />

      <Row gutter={15}>
        <Col xl={24} md={24} sm={24} xs={24}>
          <ButtonGroup
            propertyId={propertyId}
            showModalHealthSafety={showModalHealthSafety}
            searchAssetAndPolicy={getAssetsAndPolicies}
            onShowActivityModal={showModalActivity}
            onOpenSafetyDocuments={() => setVisibleSafetyDocuments(true)}
          />
          {/* Traffic-light KPIs hidden for now (can be restored later). */}
        </Col>
      </Row>

      <Spin spinning={dashboardLoading}>
        {/* Headline KPI tiles — cards use height:100%, so the flex row equalises them. */}
        <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
          {isTileVisible("safety_performance") && (
            <Col xs={24} sm={12} xl={4}>
              <SafetyPerformanceTile data={d.safety_performance} />
            </Col>
          )}
          {isTileVisible("total_records") && (
            <Col xs={24} sm={12} xl={4}>
              <TotalRecordsTile data={d.total_records} />
            </Col>
          )}
          {isTileVisible("incidents") && (
            <Col xs={24} sm={12} xl={4}>
              <IncidentsTile data={d.incidents} onViewAll={() => goTo("/incidents", "incidents")} />
            </Col>
          )}
          {isTileVisible("open_actions") && (
            <Col xs={24} sm={12} xl={4}>
              <OpenActionsTile data={d.open_actions} onViewAll={() => goTo("/incidents", "incidents")} />
            </Col>
          )}
          {isTileVisible("near_miss_ratio") && (
            <Col xs={24} sm={12} xl={4}>
              <NearMissRatioTile data={d.near_miss_ratio} />
            </Col>
          )}
          {isTileVisible("training_compliance") && (
            <Col xs={24} sm={12} xl={4}>
              <TrainingComplianceTile data={d.training_compliance} onViewAll={() => goTo("/training-module", "training-module")} />
            </Col>
          )}
        </Row>

        {/* Charts / breakdown tiles */}
        <Row gutter={[16, 16]} style={{ marginTop: 8 }} align="stretch">
          {isTileVisible("risk_heat_map") && (
            <Col xs={24} xl={12}>
              <RiskHeatMapTile data={d.risk_heat_map} onViewAll={() => goTo("/hazards", "hazards")} />
            </Col>
          )}
          {isTileVisible("incidents_over_time") && (
            <Col xs={24} xl={12}>
              <IncidentsOverTimeTile data={d.incidents_over_time} onViewAll={() => goTo("/incidents", "incidents")} />
            </Col>
          )}
          {isTileVisible("top_hazard_categories") && (
            <Col xs={24} xl={12}>
              <TopHazardCategoriesTile data={d.top_hazard_categories} onViewAll={() => goTo("/hazards", "hazards")} />
            </Col>
          )}
          {isTileVisible("observations_status") && (
            <Col xs={24} xl={12}>
              <ObservationsStatusTile data={d.observations_status} onViewAll={() => goTo("/health-safety", "health-safety")} />
            </Col>
          )}
        </Row>
      </Spin>
      {/* Maps — Live Safety Map (with layer filter) + Weather Radar, in tiles. */}
      <Row gutter={[16, 16]} style={{ marginTop: 8 }} className="maps_rows" align="stretch">
        <Col xs={24} xl={14}>
          <SectionCard
            title="Live Safety Map"
            fill
            extra={<ViewAllLink label="View full map" onClick={() => goTo("/map", "map")} />}
          >
            <div style={{ marginBottom: 10 }}>
              <Radio.Group
                value={mapLayer}
                onChange={(e) => setMapLayer(e.target.value)}
                size="small"
                buttonStyle="solid"
              >
                <Radio.Button value="all">All</Radio.Button>
                <Radio.Button value="incidents">Incidents</Radio.Button>
                <Radio.Button value="hazards">Hazards</Radio.Button>
                <Radio.Button value="observations">Observations</Radio.Button>
                <Radio.Button value="assets">Assets</Radio.Button>
              </Radio.Group>
            </div>
            <div id="health-safety-map" style={{ height: 460 }}>
              <MapHealthSafety
                onSaved={onSaved}
                propertyId={propertyId}
                position={position}
                updatePropertyDetail={updatePropertyDetail}
                primaryObjects={primaryObjects}
                onHazardUpdated={handleHazardUpdated}
                onShowActivityModal={showModalActivity}
                activeLayer={mapLayer}
              />
            </div>
          </SectionCard>
        </Col>
        <Col xs={24} xl={10}>
          <SectionCard title="Weather Radar" fill>
            <div className="hs-weather-tile" style={{ height: 500, overflow: "hidden", borderRadius: 10 }}>
              <WeatherMap />
            </div>
          </SectionCard>
        </Col>
      </Row>

      {/* Safety Records — Assets / Activities / Hazards / Observations + a
          Safety Documents tab, in a two-tab master-detail table. */}
      <Row style={{ marginTop: 16 }}>
        <Col xl={24} md={24} sm={24} xs={24}>
          <SafetyRecords
            propertyId={propertyId}
            healthAndSafetyAssets={healthAndSafetyAssets}
            healthAndSafetyPolicies={healthAndSafetyPolicies}
            onEditAsset={showModalHealthSafety}
            onEditActivity={handleActivityEdit}
            onEditHazard={handleEditHazard}
            goTo={goTo}
          />
        </Col>
      </Row>

      <SafetyDocumentsModal
        visible={visibleSafetyDocuments}
        onCancel={() => setVisibleSafetyDocuments(false)}
        propertyId={propertyId}
      />

      <ModalHealthSafety
        cancelModalHealthSafety={cancelModalHealthSafety}
        visibleModalHealthSafety={visibleModalHealthSafety}
        onSaved={onSaved}
        propertyId={propertyId}
        position={position}
        getDataAsset={getDataAsset}
        searchAssetAndPolicy={getAssetsAndPolicies}
        editingAsset={editingAsset}
      />
      <ModalActivity
        cancelModalActivity={cancelModalActivity}
        visibleModalActivity={visibleModalActivity}
        propertyId={propertyId}
        activityActive={activityActive}
        searchAssetAndPolicy={getAssetsAndPolicies}
        editingPolicy={editingPolicy}
        propertyCenter={propertyCenterPoint}
        saveToHazardsTable={activityActive === 'hazard'}
        additionalData={additionalActivityData}
      />
      <ObservationModal
        propertyId={propertyId}
        primaryObjects={primaryObjects}
        onSaved={handleObservationSaved}
        editLocation={() => {}}
      />
      <AddActivityModal
        visibleActivity={visibleTrainingModal}
        dataId={trainingFacilityId}
        propertyId={propertyId}
        cancelModalActivity={cancelTrainingModal}
        getDataActivity={getAssetsAndPolicies}
        onSaved={refreshHealthSafetyData}
        defaultActivityType="training_session"
        assetName={assetName}
      />
    </HealthSafetyWrapper>
  );
};
export default Dashboard;
